import { graphql } from "react-apollo"
import PropTypes from "prop-types"
import gql from "graphql-tag"
import AssetAlertsListTable from "./AssetAlertsListTable"
import { ASSET_ALERT_INFO_FRAGMENT } from "../../helpers/sharedConstants"

const query = gql`
  query AssetAlertsListTable($facilityId: ID!) {
    facility(id: $facilityId) {
      id
      assetAlerts {
        ...AssetAlertInfo
      }
    }
  }

  ${ASSET_ALERT_INFO_FRAGMENT}
`

const AssetAlertsListTableWithData = graphql(query, {
  options: props => ({
    variables: {
      facilityId: props.facilityId,
    },
  }),
  props: ({ data: { error, loading, facility }, ownProps }) => {
    if (error && error.networkError) {
      console.warn("Network error, not able to refresh")
      return
    }
    if (error) {
      throw error
    }
    if (loading) {
      return { loading }
    }
    if (!facility) {
      error = Error("No facility with id " + ownProps.facilityId + " available")
      error.number = 204
      throw error
    }
    return {
      loading,
      assetAlerts: facility && facility.assetAlerts,
      ...ownProps,
    }
  },
})(AssetAlertsListTable)

AssetAlertsListTableWithData.propTypes = {
  facilityId: PropTypes.string.isRequired,
}

export default AssetAlertsListTableWithData
